import { useEffect, useState } from "react";
import { useFlowStore } from "../../store/FlowStateStore.ts";
import { CanvasNode, CanvasNodeData } from "../../models/CanvasNode";

const CateglougeMessage: React.FC<any> = (data) => {
  const [body, setBody] = useState<string>();
  const [footer, setFooter] = useState<string>();
  const { nodes, setNodes } = useFlowStore();

  useEffect(() => {
    const updatedNodes = nodes.map((node) => {
      if (node.data.id == data.nodeId) {
        return {
          ...node,
          data: {
            ...node.data,
            content: [...(node.data as CanvasNodeData).content.map((nodeContent) => {
              if (nodeContent.id == data.subNodeId) {
                return {
                  ...nodeContent,
                  data: {
                    body: body,
                    footer: footer
                  }
                }
              }
              return nodeContent
            })]
          }
        }
      }
      return node;
    });
    setNodes([...(updatedNodes as CanvasNode[])]);
  }, [body, footer]);

  return (
    <div className="node-body">
      <input
        type="text"
        value={body}
        onChange={(event) => setBody(event.target.value)}
        placeholder="Body"
      />
      <input
        type="text"
        value={footer}
        onChange={(event) => setFooter(event.target.value)}
        placeholder="Footer"
      />
    </div>
  );
}

export default CateglougeMessage;
